import { Currency } from '@/types';
import { fetchCurrency } from '@/utils/http/fetchCurrency';
import { Thunk } from '@/redux/types';
import { CoreActionTypes, CurrencyFetchAction } from '../types';

export const fetchCurrencyAction =
  (currencyId: string): Thunk<Promise<Currency>, CurrencyFetchAction> =>
  (dispatch) =>
    fetchCurrency(currencyId).then((currency) => {
      dispatch({ type: CoreActionTypes.CURRENCY_FETCH, currency });
      return currency;
    });
